export default __webpack_public_path__ + "50b4f4d9b4be052727aa6e6689fec040.png";